import LetterbooksParentContextType from "types/LetterbooksParentContextType";
import {
  LetterbooksConditionType,
} from "../../types";
import {
  listConditions,
  libraryConditions,
  tagConditions,
  authorConditions,
  goalConditions,
  promptConditions,
  seriesConditions,
  publisherConditions,
  characterConditions
} from "./contexts";
import LetterbookTypeType from "types/LetterbookTypeType";
import { LetterbooksSerializersLetterbooks } from "types/serializers";

interface GeneratorInterface {
  [key: string]: (context: LetterbooksParentContextType) => LetterbooksConditionType;
}

const generator: GeneratorInterface &
  Record<
    LetterbookTypeType,
    (context: LetterbooksParentContextType) => LetterbooksConditionType
  > = {
  list: listConditions,
  library: libraryConditions,
  tag: tagConditions,
  author: authorConditions,
  goal: goalConditions,
  prompt: promptConditions,
  series: seriesConditions,
  publisher: publisherConditions,
  character: characterConditions,
};

export function findConditions(
  context: LetterbooksSerializersLetterbooks
): LetterbooksConditionType {
  return generator[context.type](context.context);
}
